import { LighthouseIcon } from './LighthouseIcon';

/**
 * author: Michael Irigoyen
 * id 95534506-8ECD-49B3-9F87-64D52CC874BA
 * name lighthouse
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lighthouse.svg
 * tags
 */
export const BeaconIcon = LighthouseIcon;
export default BeaconIcon